import Cookies from 'js-cookie';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect, useMemo } from 'react';

import { useStores } from 'src/components/common/root-store-provider/root-store-provider';

import {
  FACEBOOK_IDS,
  FACEBOOK_PIXEL_ID,
  PIXEL_VARIANT_MAP,
} from '../../constants';

const FbPixel = observer(() => {
  const storedExternalId = Cookies.get('extId');

  const externalId = useMemo(() => {
    if (storedExternalId) return storedExternalId;

    const randomInt = Math.floor(Math.random() * 100_000_000);
    const id = `${randomInt}`;
    Cookies.set('extId', id, { expires: 365 });
    return id;
  }, [storedExternalId]);

  const {
    authStore: { variant },
    analyticsStore: { setFbPixelId },
  } = useStores();

  const { isReady, query } = useRouter();

  const fbPixelId = useMemo(() => {
    if (!isReady || query['reset'] !== undefined) return null;

    return PIXEL_VARIANT_MAP.get(variant) || FACEBOOK_PIXEL_ID;
  }, [isReady, query, variant]);

  useEffect(() => {
    if (fbPixelId) {
      setFbPixelId(fbPixelId);
    }
  }, [fbPixelId, setFbPixelId]);

  return FACEBOOK_IDS.size > 0 ? (
    <Script id="facebook-pixel">
      {`!function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq.disablePushState = true;
        fbq('init', ${fbPixelId}, {'extern_id': ${externalId}});
        fbq('track', 'PageView');`}
    </Script>
  ) : null;
});

export default FbPixel;
